import React from 'react';
import { DropDown } from './common';
import {validatable} from 'components/utils';

class DropDownChonStateXuLyDon extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      data: this.props.data
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.coQuanQuanLyId != nextProps.coQuanQuanLyId && nextProps.coQuanQuanLyId) {
      this.setState({
        coQuanQuanLyId: nextProps.coQuanQuanLyId,
        vaiTro: nextProps.vaiTro
      });

      this.getCongChucPhongBan(nextProps.coQuanQuanLyId);
    }
  }

  render() {

    return (
      <DropDown
        bindValidator={this}
        channel="formTaoDon"
        isValid={this.props.isValid}
        className={this.props.className}
        require={this.props.require}
        selectedValue={this.props.value}
        label={this.props.label}
        options={ this.state.data }
        keyName='type'
        valueName='tenVietTat'
        onChange={ this.onChange.bind(this) }
        placeholder={ this.props.placeholder }
        name={this.props.name}/>
    )
  }
}

DropDownChonStateXuLyDon.defaultProps = {
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  className: 'col-input',
  label: 'Hướng xử lý',
  name:''
}


export default validatable(DropDownChonStateXuLyDon);



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-chonstatexulydon.jsx